import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as getters from "./getters";
import app from "./modules/app";
import admin from "./modules/admin";
import loginModule from "./modules/login";
import NoticeAdministrationModule from "./modules/NoticeAdministration";
import ContractManagementModule from "./modules/ContractManagement";
import SiteManagementModule from "./modules/SiteManagement";
import BookingManagementModule from "./modules/BookingManagement";
import EnumerationManagementModule from "./modules/EnumerationManagement";
import CompanyManagementModule from "./modules/CompanyManagement";
import UserManagementModule from "./modules/UserManagement";
import ReportRepairModule from "./modules/ReportRepair";
import ComplaintProposalPraiseModule from "./modules/ComplaintProposalPraise";
import PreferentialManagementModule from "./modules/PreferentialManagement";
import AccessControlModule from "./modules/AccessControl";
import AuditvisitorsModule from "./modules/Auditvisitors";
import SatisfactionSurveyModule from "./modules/SatisfactionSurvey";
import SatisfactionSurveyTemplateModule from "./modules/SatisfactionSurveyTemplate";
import ReportFormFinanceModule from "./modules/ReportFormFinance";
import InspectionModule from "./modules/Inspection";
import EnterpriseServicesModule from "./modules/EnterpriseServices";
import DepartmentModule from "./modules/Department";
import ExpenseBillModule from "./modules/ExpenseBill";
import AccountModule from "./modules/Account";

if (process.env.NODE_ENV === "development") {
    Vue.use(Vuex);
}

// const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    actions,
    getters,
    modules: {
        app,
        admin,
        loginModule,
        NoticeAdministrationModule,
        ContractManagementModule,
        SiteManagementModule,
        BookingManagementModule,
        EnumerationManagementModule,
        CompanyManagementModule,
        UserManagementModule,
        ReportRepairModule,
        ComplaintProposalPraiseModule,
        PreferentialManagementModule,
        AccessControlModule,
        AuditvisitorsModule,
        SatisfactionSurveyModule,
        SatisfactionSurveyTemplateModule,
        ReportFormFinanceModule,
        InspectionModule,
        EnterpriseServicesModule,
        DepartmentModule,
        ExpenseBillModule,
        AccountModule
    }
    // plugins: debug ? [createLogger()] : []
});
